import { Component } from '@combos-fun/engine';
import { Field } from '@combos-fun/inspector-decorator';

export interface SpriteAnimation3DParams {
  resource?: string;
  autoPlay?: boolean;
  speed?: number;
  positionX?: number;
  positionY?: number;
  positionZ?: number;
  rotationX?: number;
  rotationY?: number;
  rotationZ?: number;
  scaleX?: number;
  scaleY?: number;
}

export default class SpriteAnimation3D extends Component<SpriteAnimation3DParams> {
  static componentName: string = 'SpriteAnimation3D';

  @Field({

    type: 'string',

    group: 'SpriteAnimation3D',

    label: 'resource',

    description: 'Resource id from the asset registry.',

    editor: 'text',

  })

  resource: string = '';
  @Field({
    type: 'boolean',
    group: 'SpriteAnimation3D',
    label: 'autoPlay',
    description: 'Start playing automatically when loaded.',
    editor: 'toggle',
  })
  autoPlay: boolean = true;
  @Field({
    type: 'number',
    step: 10,
    group: 'SpriteAnimation3D',
    label: 'speed',
    description: 'Playback speed.',
    editor: 'number-stepper',
  })
  speed: number = 100;
  @Field({
    type: 'number',
    step: 0.1,
    group: 'SpriteAnimation3D',
    label: 'positionX',
    description: 'Local X position.',
    editor: 'number-stepper',
  })
  positionX: number = 0;
  @Field({
    type: 'number',
    step: 0.1,
    group: 'SpriteAnimation3D',
    label: 'positionY',
    description: 'Local Y position.',
    editor: 'number-stepper',
  })
  positionY: number = 0;
  @Field({
    type: 'number',
    step: 0.1,
    group: 'SpriteAnimation3D',
    label: 'positionZ',
    description: 'Local Z position.',
    editor: 'number-stepper',
  })
  positionZ: number = 0;
  @Field({
    type: 'number',
    step: 0.01,
    group: 'SpriteAnimation3D',
    label: 'rotationX',
    description: 'Rotation around X in radians.',
    editor: 'number-stepper',
  })
  rotationX: number = 0;
  @Field({
    type: 'number',
    step: 0.01,
    group: 'SpriteAnimation3D',
    label: 'rotationY',
    description: 'Rotation around Y in radians.',
    editor: 'number-stepper',
  })
  rotationY: number = 0;
  @Field({
    type: 'number',
    step: 0.01,
    group: 'SpriteAnimation3D',
    label: 'rotationZ',
    description: 'Rotation around Z in radians.',
    editor: 'number-stepper',
  })
  rotationZ: number = 0;
  @Field({
    type: 'number',
    step: 0.1,
    group: 'SpriteAnimation3D',
    label: 'scaleX',
    description: 'Scale on X.',
    editor: 'number-stepper',
  })
  scaleX: number = 1;
  @Field({
    type: 'number',
    step: 0.1,
    group: 'SpriteAnimation3D',
    label: 'scaleY',
    description: 'Scale on Y.',
    editor: 'number-stepper',
  })
  scaleY: number = 1;

  init(obj?: SpriteAnimation3DParams) {
    if (obj) Object.assign(this, obj);
  }
}
